import { type Components, type Theme } from '@mui/material/styles';

const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: {
      fontSize: 12
    }
  }
};

export const formControl = { MuiFormHelperText };
